import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-what-is-kilnlink',
  templateUrl: './what-is-kilnlink.component.html',
  styleUrls: ['./what-is-kilnlink.component.scss'],
})
export class WhatIsKilnlinkComponent {
  @Input() showTrigger = true;
  @Input() color = 'medium';
  @Input() fill: 'clear' | 'outline' | 'solid' = 'clear';
  @Input() size: 'small' | 'default' | 'large' = 'default';

  isOpen = false;
  bullets: string[] = [];

  constructor(private translate: TranslateService) {}

  open(event?: Event): void {
    event?.stopPropagation();
    this.bullets = Array.from({ length: 9 }, (_, i) =>
      this.translate.instant(`LANDING.WHAT_IS_KILNLINK_BULLET_${i + 1}`)
    );
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }
}
